






















import { Component, Prop, Vue } from 'vue-property-decorator';
import ui from '@/store/modules/ui';

@Component({
    components: {},
})
export default class Modal extends Vue {
    @Prop() public modalId!: string;
    @Prop() public enableModalClose: boolean = true;

    get visible(): boolean {
        return ui.isModalVisible(this.modalId);
    }

    private mounted() {
        ui.newModal(this.modalId);
    }

    private closeModal() {
        if (this.enableModalClose) {
            ui.closeModal(this.modalId);
        }
    }
}
